import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useStudentMe } from '../../roster/hooks/useStudentMe';
import { acquireTutorProgressInvalidationBridge } from './progressInvalidationBridge';

/** Mount once at app root to coalesce progress-update events → query invalidation. */
export function AppTutorProgressBridge() {
  const queryClient = useQueryClient();
  const { enabled: studentRosterEnabled } = useStudentMe();

  useEffect(() => {
    if (!studentRosterEnabled) return;
    return acquireTutorProgressInvalidationBridge(queryClient);
  }, [queryClient, studentRosterEnabled]);

  return null;
}
